import api from './api';

// Servicio de proveedores
export const suppliersService = {
  // Obtener todos los proveedores
  getAll: async () => {
    try {
      const response = await api.get('/suppliers');
      // Normalizar la forma de retorno para que el frontend pueda usar
      // siempre `result.data` y obtener el array de proveedores.
      // Algunos endpoints devuelven { success, data } y otros pueden
      // devolver directamente un array. Aquí preferimos `response.data.data`
      // cuando existe, si no, devolvemos `response.data`.
      const inner = response.data && response.data.data ? response.data.data : response.data;
      return { data: inner };
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo proveedores');
    }
  },

  // Obtener proveedor por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/suppliers/${id}`);
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo proveedor');
    }
  },

  // Crear nuevo proveedor
  create: async (supplierData) => {
    try {
      const response = await api.post('/suppliers', supplierData);
      return response.data; // Devolver toda la estructura { success, data, message }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error creando proveedor');
    }
  },

  // Actualizar proveedor
  update: async (id, supplierData) => {
    try {
      const response = await api.put(`/suppliers/${id}`, supplierData);
      return response.data; // Devolver toda la estructura { success, data, message }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error actualizando proveedor');
    }
  },

  // Eliminar proveedor
  delete: async (id) => {
    try {
      const response = await api.delete(`/suppliers/${id}`);
      return response.data; // El delete puede retornar solo success
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error eliminando proveedor');
    }
  },

  // Obtener contactos de un proveedor
  getContacts: async (supplierId) => {
    try {
      const response = await api.get(`/suppliers/${supplierId}/contacts`);
      return response.data.data; // Extraer el array del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo contactos');
    }
  },

  // Crear nuevo contacto para un proveedor
  createContact: async (supplierId, contactData) => {
    try {
      const response = await api.post(`/suppliers/${supplierId}/contacts`, contactData);
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error creando contacto');
    }
  },

  // Actualizar contacto de un proveedor
  updateContact: async (supplierId, contactId, contactData) => {
    try {
      const response = await api.put(`/suppliers/${supplierId}/contacts/${contactId}`, contactData);
      return response.data.data; // Extraer el objeto del campo data
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error actualizando contacto');
    }
  },

  // Eliminar contacto de un proveedor
  deleteContact: async (supplierId, contactId) => {
    try {
      const response = await api.delete(`/suppliers/${supplierId}/contacts/${contactId}`);
      return response.data; // El delete puede retornar solo success
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error eliminando contacto');
    }
  },

  // Obtener conteo de productos únicos por proveedor
  getProductCounts: async () => {
    try {
      const response = await api.get('/suppliers/stats/product-counts');
      return response.data.data; // Retorna objeto { supplierId: count }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || 'Error obteniendo conteos de productos');
    }
  }
};

export default suppliersService;
